module.exports = "images/realtor-12.png";